import React from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import {PageTitle} from '../../../../_CarWash/layout/core'
import VehicleMakeList from '../../../pages/vehicle-manage-pages/vehicle-make/VehicleMakeList'
import {AddVehicleMake} from '../../../pages/vehicle-manage-pages/vehicle-make/AddVehicleMake'
import {EditVehicleMake} from '../../../pages/vehicle-manage-pages/vehicle-make/EditVehicleMake'
import NewModelRequestList from '../../../pages/vehicle-manage-pages/new-model-request/NewModelRequestList'
import {AddNewModelRequest} from '../../../pages/vehicle-manage-pages/new-model-request/AddNewModelRequest'
import {EditNewModelRequest} from '../../../pages/vehicle-manage-pages/new-model-request/EditNewModelRequest'

const NewModelRequestMasterPage: React.FC = () => {
  return (
    <Switch>
      <Route path='/vehicle/new-model-request/list'>
        <PageTitle>New Model Request List</PageTitle>
        <NewModelRequestList />
      </Route>
      <Route path='/vehicle/new-model-request/add'>
        <PageTitle>Add New Model Request </PageTitle>
        <AddNewModelRequest />
      </Route>
      <Route path='/vehicle/new-model-request/edit/:newModelReqID'>
        <PageTitle>Edit New Model Request</PageTitle>
        <EditNewModelRequest />
      </Route>
      <Redirect
        from='/vehicle/new-model-request'
        exact={true}
        to='/vehicle/new-model-request/list'
      />
      <Redirect to='/vehicle/new-model-request/list' />
    </Switch>
  )
}

export default NewModelRequestMasterPage
